// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__Qe17Q","tab":"styles_tab__q-4m6","isActive":"styles_isActive__8b-hE"};